var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pet-food 1",
    clipPath: "url(#clip0_24_7623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M86.2922 18.4053H53.2722L56.5328 25.5791V69.1778L56.7715 69.0978C57.2834 68.926 57.8177 68.8388 58.3595 68.8388C59.5397 68.8388 60.686 69.259 61.5868 70.022L61.7039 70.1212L61.821 70.022C62.7217 69.259 63.868 68.8388 65.0483 68.8388C67.8039 68.8388 70.0456 71.0806 70.0456 73.8361C70.0456 74.3364 69.9669 74.8402 69.8118 75.3336L69.7378 75.569H71.9752C72.6946 75.569 73.3204 76.0308 73.5326 76.7182L74.1728 78.7925H86.292C87.7921 78.7925 89.0084 77.5764 89.0084 76.0761V21.1216C89.0085 19.6213 87.7925 18.4053 86.2922 18.4053Z",
    fill: "#60B7FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.3933 25.7154L56.7141 25.5396L51.4373 13.9307L49.5213 13.7549H8.36724L6.26823 13.9307L0.991455 25.5396L2.36097 25.7154H55.3933Z",
    fill: "#FFF0AD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.4372 13.9307H43.345L48.6217 25.5396H56.714L51.4372 13.9307Z",
    fill: "#FFE177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M86.2924 18.4053H78.7058C80.2059 18.4053 81.4222 19.6213 81.4222 21.1216V76.0761C81.4222 77.5762 80.2059 78.7925 78.7058 78.7925H86.2924C87.7925 78.7925 89.0087 77.5764 89.0087 76.0761V21.1216C89.0087 19.6213 87.7927 18.4053 86.2924 18.4053Z",
    fill: "#26A6FE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M51.4374 13.9307V6.10102C51.4374 2.73146 48.706 0 45.3364 0H12.3693C8.99977 0 6.26831 2.73146 6.26831 6.10102V13.9307H51.4374Z",
    fill: "#FFE177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M43.345 6.10102V13.9307H51.4372V6.10102C51.4372 2.73146 48.7058 0 45.3362 0H37.71C41.0795 0 43.345 2.73146 43.345 6.10102Z",
    fill: "#FFD15B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M56.533 55.3472H89.0085V62.7462H56.533V55.3472Z",
    fill: "#BBEC6C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M81.4221 55.3472H89.0087V62.7462H81.4221V55.3472Z",
    fill: "#A2E62E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M77.9787 40.4219C77.2387 40.1078 76.6807 39.4887 76.38 38.7432C75.7737 37.2411 74.3026 36.1812 72.5835 36.1812C70.8643 36.1812 69.3932 37.2411 68.7869 38.7432C68.486 39.4887 67.9281 40.1078 67.1882 40.4219C65.6642 41.0687 64.613 42.6123 64.6979 44.391C64.7976 46.4805 66.4995 48.181 68.589 48.2793C69.4459 48.3196 70.2482 48.0961 70.9216 47.6832C71.948 47.0539 73.2189 47.0539 74.2453 47.6832C74.9189 48.0961 75.721 48.3196 76.5779 48.2793C78.6676 48.181 80.3693 46.4805 80.469 44.391C80.5541 42.6121 79.5029 41.0686 77.9787 40.4219Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M77.9787 40.4219C77.2387 40.1078 76.6807 39.4887 76.3798 38.7432C75.7735 37.2411 74.3024 36.1812 72.5833 36.1812C71.4618 36.1812 70.4479 36.6341 69.7087 37.3645C70.1027 37.7539 70.42 38.2207 70.6307 38.743C70.9316 39.4885 71.4896 40.1076 72.2294 40.4217C73.7535 41.0686 74.8046 42.6121 74.7197 44.3908C74.6647 45.5459 74.1184 46.5805 73.2892 47.293C73.6206 47.3693 73.9435 47.4983 74.2451 47.683C74.9187 48.096 75.7208 48.3194 76.5779 48.2791C78.6674 48.1809 80.3693 46.4804 80.469 44.3908C80.5541 42.6121 79.5029 41.0686 77.9787 40.4219Z",
    fill: "#F2FBFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M63.5052 37.5825C64.7349 37.5825 65.7318 36.3283 65.7318 34.7812C65.7318 33.2341 64.7349 31.98 63.5052 31.98C62.2755 31.98 61.2786 33.2341 61.2786 34.7812C61.2786 36.3283 62.2755 37.5825 63.5052 37.5825Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M81.6614 37.5825C82.8912 37.5825 83.8881 36.3283 83.8881 34.7812C83.8881 33.2341 82.8912 31.98 81.6614 31.98C80.4317 31.98 79.4348 33.2341 79.4348 34.7812C79.4348 36.3283 80.4317 37.5825 81.6614 37.5825Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M69.1436 33.0371C70.3733 33.0371 71.3702 31.7829 71.3702 30.2358C71.3702 28.6887 70.3733 27.4346 69.1436 27.4346C67.9139 27.4346 66.917 28.6887 66.917 30.2358C66.917 31.7829 67.9139 33.0371 69.1436 33.0371Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M76.0233 33.0371C77.253 33.0371 78.2499 31.7829 78.2499 30.2358C78.2499 28.6887 77.253 27.4346 76.0233 27.4346C74.7935 27.4346 73.7966 28.6887 73.7966 30.2358C73.7966 31.7829 74.7935 33.0371 76.0233 33.0371Z",
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M21.0811 25.5396V25.7153C20.9873 30.5943 16.9891 34.5343 12.0882 34.5343H0.991455V85.5112C0.991455 87.0113 2.20751 88.2275 3.7078 88.2275H32.981C32.9775 88.0586 32.9982 87.8876 33.0489 87.7195L36.3558 76.7288C36.5645 76.0348 37.1917 75.5686 37.9164 75.5686H40.2926L40.2184 75.3331C40.0632 74.84 39.9845 74.3361 39.9845 73.8356C39.9845 71.0801 42.2264 68.8383 44.9819 68.8383C46.1621 68.8383 47.3084 69.2585 48.2093 70.0215L48.3264 70.1207L48.4434 70.0215C49.3443 69.2585 50.4906 68.8383 51.6708 68.8383C52.851 68.8383 53.9972 69.2585 54.8981 70.0215L55.0152 70.1207L55.1323 70.0215C55.6023 69.6232 56.1402 69.321 56.7139 69.1206V25.5396H21.0811Z",
    fill: "#FFE177"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M51.6709 68.8385C52.8511 68.8385 53.9974 69.2586 54.8983 70.0217L55.0153 70.1208L55.1324 70.0217C55.6025 69.6234 56.1403 69.3212 56.7141 69.1208V25.5396H48.6218V69.8839C49.4935 69.2108 50.566 68.8385 51.6709 68.8385Z",
    fill: "#FFD15B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M21.2587 25.5396H0.991455V34.7101H12.088C17.1528 34.7101 21.2587 30.6043 21.2587 25.5396Z",
    fill: "#FE646F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M15.1061 25.5396C15.1061 30.6043 11.0003 34.7101 5.93555 34.7101H12.0879C17.1527 34.7101 21.2584 30.6043 21.2584 25.5396H15.1061Z",
    fill: "#FD4755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M36.3558 76.7289C36.5645 76.0349 37.1918 75.5687 37.9164 75.5687H40.2926L40.2184 75.3332C40.0632 74.8401 39.9845 74.3361 39.9845 73.8357C39.9845 72.893 40.2471 72.0107 40.7027 71.2573H11.0948C10.0946 71.2573 9.28394 72.068 9.28394 73.0682V77.1427C9.28394 78.1428 10.0946 78.9536 11.0948 78.9536H35.6863L36.3558 76.7289Z",
    fill: "#0593FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M32.1659 78.9537H35.6865L36.3559 76.7289C36.5645 76.0349 37.1919 75.5687 37.9165 75.5687H40.2927L40.2185 75.3332C40.0633 74.8401 39.9845 74.3361 39.9845 73.8357C39.9845 72.893 40.2471 72.0107 40.7028 71.2573H32.1658C33.166 71.2573 33.9767 72.068 33.9767 73.0682V77.1427C33.9767 78.143 33.166 78.9537 32.1659 78.9537Z",
    fill: "#0182FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M43.0358 42.3301L38.5572 40.167C36.9755 39.403 35.0836 39.7233 33.8417 40.9654C33.2664 41.5407 32.8874 42.2607 32.7246 43.0283C34.5854 43.5084 36.3468 44.3342 37.9348 45.488C40.6411 47.4542 41.8723 50.8102 41.1319 54.0212L41.819 54.1952C44.4281 54.8558 46.9615 52.8837 46.9615 50.1923V48.5857C46.9613 45.9201 45.4361 43.4896 43.0358 42.3301Z",
    fill: "#EA9B58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M19.7709 45.488C21.3589 44.3342 23.1202 43.5084 24.981 43.0283C24.8181 42.2607 24.4393 41.5407 23.8637 40.9654C22.6217 39.7233 20.7299 39.403 19.1482 40.167L14.6697 42.3301C12.2694 43.4894 10.7441 45.9201 10.7441 48.5857V50.1923C10.7441 52.8837 13.2777 54.8556 15.8866 54.1952L16.5739 54.0212C15.8335 50.81 17.0647 47.4542 19.7709 45.488Z",
    fill: "#EA9B58"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M19.6642 45.3414C16.7042 47.4919 15.4657 51.3037 16.5963 54.7835L18.8702 61.7818C19.6071 64.0496 21.7203 65.5851 24.105 65.5851H33.6003C35.9848 65.5851 38.0982 64.0496 38.8351 61.7818L41.109 54.7835C42.2396 51.3039 41.0011 47.4919 38.0411 45.3414C32.5622 41.3608 25.1431 41.3608 19.6642 45.3414Z",
    fill: "#D88A55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M38.0412 45.3416C34.4827 42.7562 30.1059 41.852 25.9736 42.6251C28.2036 43.0422 30.3625 43.9465 32.2828 45.3416C35.2428 47.4921 36.4813 51.304 35.3507 54.7837L33.0768 61.7821C32.3399 64.0499 30.2267 65.5853 27.842 65.5853H33.6004C35.9849 65.5853 38.0983 64.0499 38.8352 61.7821L41.1091 54.7837C42.2397 51.3041 41.0012 47.4921 38.0412 45.3416Z",
    fill: "#C57A44"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M29.3984 59.942C29.2643 60.1069 29.0653 60.2016 28.8528 60.2016C28.6403 60.2016 28.4413 60.1069 28.3072 59.942L27.5344 58.9912V65.5849H30.1711V58.9914L29.3984 59.942Z",
    fill: "#7A6D79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M23.593 54.0973C22.8648 54.0973 22.2747 53.507 22.2747 52.7789V51.2744C22.2747 50.5463 22.8648 49.9561 23.593 49.9561C24.3213 49.9561 24.9114 50.5463 24.9114 51.2744V52.7789C24.9114 53.5072 24.3211 54.0973 23.593 54.0973Z",
    fill: "#7A6D79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M34.1125 54.0973C33.3843 54.0973 32.7942 53.507 32.7942 52.7789V51.2744C32.7942 50.5463 33.3843 49.9561 34.1125 49.9561C34.8408 49.9561 35.4309 50.5463 35.4309 51.2744V52.7789C35.4309 53.5072 34.8408 54.0973 34.1125 54.0973Z",
    fill: "#7A6D79"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M46.7917 39.0244C48.792 39.0244 50.4135 37.4028 50.4135 35.4026C50.4135 33.4023 48.792 31.7808 46.7917 31.7808C44.7915 31.7808 43.1699 33.4023 43.1699 35.4026C43.1699 37.4028 44.7915 39.0244 46.7917 39.0244Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M46.7918 31.7808C46.2086 31.7808 45.6596 31.9219 45.1716 32.1668C46.3575 32.7618 47.1731 33.9854 47.1731 35.4026C47.1731 36.8197 46.3573 38.0433 45.1716 38.6383C45.6596 38.8832 46.2087 39.0244 46.7918 39.0244C48.792 39.0244 50.4136 37.4028 50.4136 35.4026C50.4136 33.4023 48.792 31.7808 46.7918 31.7808Z",
    fill: "#F2FBFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M35.6437 9.22873H22.0621C20.812 9.22873 19.7986 8.21535 19.7986 6.9652C19.7986 5.71504 20.812 4.70166 22.0621 4.70166H35.6437C36.8938 4.70166 37.9072 5.71504 37.9072 6.9652C37.9072 8.21535 36.8938 9.22873 35.6437 9.22873Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M69.9289 75.5686C70.1213 75.0267 70.227 74.4436 70.227 73.8357C70.227 70.9758 67.9084 68.6572 65.0485 68.6572C63.7732 68.6572 62.6063 69.119 61.7041 69.8835C60.8018 69.1192 59.6349 68.6572 58.3596 68.6572C57.0843 68.6572 55.9175 69.119 55.0152 69.8835C54.1128 69.1192 52.9461 68.6572 51.6708 68.6572C50.3955 68.6572 49.2287 69.119 48.3264 69.8835C47.4239 69.1192 46.2573 68.6572 44.982 68.6572C42.122 68.6572 39.8035 70.9758 39.8035 73.8357C39.8035 74.4436 39.9091 75.0267 40.1016 75.5686H69.9289Z",
    fill: "#D88A55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M64.5583 73.8357C64.5583 74.4439 64.4512 75.0267 64.2584 75.5686H69.9289C70.1214 75.0267 70.2271 74.4436 70.2271 73.8357C70.2271 70.9758 67.9085 68.6572 65.0485 68.6572C64.0019 68.6572 63.0288 68.9687 62.2146 69.5027C63.6256 70.4279 64.5583 72.0224 64.5583 73.8357Z",
    fill: "#C57A44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M77.0975 87.6551L73.7058 76.6646C73.4715 75.9055 72.7699 75.3877 71.9754 75.3877H37.9164C37.1173 75.3877 36.4126 75.9115 36.1823 76.6769L32.8753 87.6674C32.5257 88.8297 33.3958 90 34.6094 90H75.3671C76.5862 90 77.457 88.82 77.0975 87.6551Z",
    fill: "#FE646F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M77.0975 87.6551L73.7058 76.6646C73.4715 75.9055 72.7699 75.3877 71.9754 75.3877H64.4238C65.2184 75.3877 65.9199 75.9055 66.1542 76.6646L69.5459 87.6551C69.9054 88.8198 69.0346 90 67.8155 90H75.3671C76.5861 90 77.457 88.82 77.0975 87.6551Z",
    fill: "#FD4755"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M62.621 84.0415H47.4094C46.6812 84.0415 46.0911 83.4512 46.0911 82.7231C46.0911 81.9951 46.6812 81.4048 47.4094 81.4048H62.621C63.3493 81.4048 63.9394 81.9951 63.9394 82.7231C63.9394 83.4512 63.3493 84.0415 62.621 84.0415Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M13.0192 9.22873C14.2693 9.22873 15.2827 8.21531 15.2827 6.9652C15.2827 5.71508 14.2693 4.70166 13.0192 4.70166C11.769 4.70166 10.7556 5.71508 10.7556 6.9652C10.7556 8.21531 11.769 9.22873 13.0192 9.22873Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M44.7093 9.22873C45.9595 9.22873 46.9729 8.21531 46.9729 6.9652C46.9729 5.71508 45.9595 4.70166 44.7093 4.70166C43.4592 4.70166 42.4458 5.71508 42.4458 6.9652C42.4458 8.21531 43.4592 9.22873 44.7093 9.22873Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M29.5347 60.0528L31.7297 57.3523C32.1966 56.778 31.7879 55.9189 31.0477 55.9189H26.6577C25.9175 55.9189 25.5088 56.7778 25.9757 57.3523L28.1706 60.0528C28.5224 60.4856 29.183 60.4856 29.5347 60.0528Z",
    fill: "#685E68"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_7623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.dc350293160d50c67d905eaf2c6fcd4f.svg";
export { ForwardRef as ReactComponent };